import { Amazon, Instagram } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Instagram,
  React
};